export const NOT_DETERMINED = 'not_determined';
export const AUTHORIZED = 'authorized';
export const DENIED = 'denied';
